module.exports = __webpack_public_path__ + "static/media/ratio.b9628a9a.png";